/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const CalendarMonth: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19Z" />

      <path d="M8.98984 18H7.78281V14.6953L7.79453 14.1523L7.81406 13.5586C7.61354 13.7591 7.47422 13.8906 7.39609 13.9531L6.73984 14.4805L6.15781 13.7539L7.99766 12.2891H8.98984V18ZM14.3906 18H13.1992V15.4492C13.1992 15.1341 13.1458 14.8984 13.0391 14.7422C12.9349 14.5833 12.7695 14.5039 12.543 14.5039C12.2383 14.5039 12.0169 14.6159 11.8789 14.8398C11.7409 15.0638 11.6719 15.4323 11.6719 15.9453V18H10.4805V13.6328H11.3906L11.5508 14.1914H11.6172C11.7344 13.9909 11.9036 13.8346 12.125 13.7227C12.3464 13.6081 12.6003 13.5508 12.8867 13.5508C13.5404 13.5508 13.9831 13.7643 14.2148 14.1914H14.3203C14.4375 13.9883 14.6094 13.8307 14.8359 13.7188C15.0651 13.6068 15.3229 13.5508 15.6094 13.5508C16.1042 13.5508 16.4779 13.6784 16.7305 13.9336C16.9857 14.1862 17.1133 14.5924 17.1133 15.1523V18H15.918V15.4492C15.918 15.1341 15.8646 14.8984 15.7578 14.7422C15.6536 14.5833 15.4883 14.5039 15.2617 14.5039C14.9701 14.5039 14.7513 14.6081 14.6055 14.8164C14.4622 15.0247 14.3906 15.3555 14.3906 15.8086V18Z" />

    </StyledIconBase>
  )
})

CalendarMonth.displayName = 'CalendarMonth'

export const CalendarMonthDimensions = {height: 24, width: 24}
